import React from 'react';
import BravoLoader from './BravoLoader';

export default class Loading extends React.Component
{
    static defaultProps = {
        loading: true
    };

    render ()
    {
        return <BravoLoader loading={this.props.loading} variant="inline" />;
    }
}
